// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"465":"calentario","658":"torneo","999":"institucion"}[chunkId] || chunkId) + "." + {"46":"fab627f4","465":"e2cf4be8","535":"3bf339be","658":"b2a13d40","756":"6fc758a3","804":"c951559f","958":"c4450058","999":"4f19b27c"}[chunkId] + ".css";
};